import React from "react";

import EventsWelcome from "../../components/events/EventsWelcome";
import PageWrapper from "../../components/ui/layout/PageWrapper";
import counterpart from "counterpart";
import Helmet from "react-helmet";
import NavigationAlertCurrencyMismatch from "../../components/ui/navigation-alert/NavigationAlertCurrencyMismatch";

interface IEventsProps {
}

export const Events = (props: IEventsProps) => {
  return (
    <div>
      <Helmet title={counterpart("NAVBAR_EVENTS")}/>
      <NavigationAlertCurrencyMismatch />
      <PageWrapper>
        <EventsWelcome />
      </PageWrapper>
    </div>
  )
}

export default Events;